package diana.soleil.design.iraniancanadienbazzar.navigation

import androidx.compose.runtime.Composable
import diana.soleil.design.iraniancanadienbazzar.core.common.requestPushPermission
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.runtime.remember
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.rememberNavController
import androidx.navigation.toRoute
import diana.soleil.design.iraniancanadienbazzar.auth.AuthViewModel
import diana.soleil.design.iraniancanadienbazzar.auth.SignInRoute
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.auth.SignUpRoute
import diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.AddBusinessRoute
import diana.soleil.design.iraniancanadienbazzar.feature.admin.AdminRoute
import diana.soleil.design.iraniancanadienbazzar.feature.business.AllReviewsRoute
import diana.soleil.design.iraniancanadienbazzar.feature.business.AllPhotosRoute
import diana.soleil.design.iraniancanadienbazzar.feature.business.BusinessDetailRoute
import diana.soleil.design.iraniancanadienbazzar.feature.business.ClaimBusinessRoute
import diana.soleil.design.iraniancanadienbazzar.feature.business.BusinessListRoute
import diana.soleil.design.iraniancanadienbazzar.feature.business.MapRoute
import diana.soleil.design.iraniancanadienbazzar.feature.business.SearchRoute
import diana.soleil.design.iraniancanadienbazzar.feature.business.WriteReviewRoute
import diana.soleil.design.iraniancanadienbazzar.feature.categories.CategoriesRoute
import diana.soleil.design.iraniancanadienbazzar.feature.chat.ConversationRoute
import diana.soleil.design.iraniancanadienbazzar.feature.home.NewsDetailRoute
import diana.soleil.design.iraniancanadienbazzar.feature.home.NewsListRoute
import diana.soleil.design.iraniancanadienbazzar.feature.home.NotificationsRoute
import diana.soleil.design.iraniancanadienbazzar.feature.chat.InboxRoute
import diana.soleil.design.iraniancanadienbazzar.feature.chat.NewMessageRoute
import diana.soleil.design.iraniancanadienbazzar.feature.chat.ChannelRoute
import diana.soleil.design.iraniancanadienbazzar.feature.chat.PeopleMapRoute
import diana.soleil.design.iraniancanadienbazzar.feature.chat.PeopleRoute
import diana.soleil.design.iraniancanadienbazzar.feature.chat.PersonProfileRoute
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.DashboardRoute
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.EditListingRoute
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.ListingAnalyticsRoute
import diana.soleil.design.iraniancanadienbazzar.feature.dashboard.ManageReviewsRoute
import diana.soleil.design.iraniancanadienbazzar.core.data.FeatureFlags
import diana.soleil.design.iraniancanadienbazzar.feature.marketplace.MarketplaceItemDetailRoute
import diana.soleil.design.iraniancanadienbazzar.feature.onboarding.WelcomeScreen
import diana.soleil.design.iraniancanadienbazzar.feature.events.EventsRoute
import diana.soleil.design.iraniancanadienbazzar.feature.events.EventDetailRoute
import diana.soleil.design.iraniancanadienbazzar.feature.events.EventTicketsRoute
import diana.soleil.design.iraniancanadienbazzar.feature.events.MyTicketsRoute
import diana.soleil.design.iraniancanadienbazzar.feature.orders.CartRoute
import diana.soleil.design.iraniancanadienbazzar.feature.orders.CheckoutRoute
import diana.soleil.design.iraniancanadienbazzar.feature.orders.ManageOrdersRoute
import diana.soleil.design.iraniancanadienbazzar.feature.orders.ManageProductsRoute
import diana.soleil.design.iraniancanadienbazzar.feature.orders.OrderConfirmationRoute
import diana.soleil.design.iraniancanadienbazzar.feature.orders.OrderHistoryRoute
import diana.soleil.design.iraniancanadienbazzar.feature.orders.ProductDetailRoute
import diana.soleil.design.iraniancanadienbazzar.feature.orders.ProductListingsSection
import diana.soleil.design.iraniancanadienbazzar.feature.orders.PromotionsSection
import diana.soleil.design.iraniancanadienbazzar.feature.profile.BlockedUsersRoute
import diana.soleil.design.iraniancanadienbazzar.feature.profile.SettingsScreen
import diana.soleil.design.iraniancanadienbazzar.feature.profile.TermsRoute
import diana.soleil.design.iraniancanadienbazzar.feature.feed.FeedDeepLinks
import diana.soleil.design.iraniancanadienbazzar.feature.gems.CookModeRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.DanestanihaRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.FalRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.GemsHubRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.PoemDetailRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.PoetPoemsRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.PoetryRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.StoriesRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.StoryDetailRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.ShahnamehRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.TaleDetailRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.JokesRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.RecipeDetailRoute
import diana.soleil.design.iraniancanadienbazzar.feature.gems.RecipesRoute
import diana.soleil.design.iraniancanadienbazzar.notifications.NotificationDeepLinks
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/**
 * Pops only when there is somewhere to go back TO. A double-tapped back button (common on web,
 * where the first canvas click often only registers as hover so users click twice) must never pop
 * the start destination and leave an empty NavHost — that renders as a dead blank-white screen.
 */
private fun NavHostController.safePopBackStack() {
    if (previousBackStackEntry != null) popBackStack()
}

/**
 * Root navigation host. Reusable DS components and feature screens are reached via
 * [NavHostController.navigate] using type-safe serializable [Route] objects.
 */
@Composable
fun AppNavHost(
    navController: NavHostController = rememberNavController(),
    authViewModel: AuthViewModel = koinViewModel(),
) {
    // Wait for Firebase to restore the persisted session before choosing the start destination.
    // `currentUser` is null until that async restore completes (notably on web/JS), so deciding from
    // the snapshot alone flashed Welcome and stranded returning users there. A brief splash (instant
    // on native, a few frames on web) is shown until the first auth-state emission resolves.
    val sessionResolved by authViewModel.sessionResolved.collectAsState()
    // Subscribe to `session` now (during the splash) so its WhileSubscribed flow is live and holds the
    // restored value by the time `sessionResolved` flips — reading the snapshot cold could be stale.
    val session by authViewModel.session.collectAsState()
    if (!sessionResolved) {
        LoadingState()
        return
    }
    // First-run gate: signed-out cold starts see the onboarding wizard once (language → value pager
    // → city → interests, every step skippable), then Welcome. Deep links still navigate on top
    // after start-destination resolution, so a QR/App Link never gets trapped in the wizard.
    val appPreferences = koinInject<diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences>()
    val startDestination: Route = remember {
        when {
            session != null -> Route.Main
            !appPreferences.onboardingComplete -> Route.Onboarding
            else -> Route.Welcome
        }
    }
    val features by koinInject<FeatureFlags>().available.collectAsState()

    // Route a tapped system notification (cold start or foreground) to its screen — the platform
    // entry point parses the FCM payload into NotificationDeepLinks; consume() keeps re-composition
    // from re-navigating.
    val pendingDeepLink by NotificationDeepLinks.pending.collectAsState()
    LaunchedEffect(pendingDeepLink) {
        when (val target = pendingDeepLink) {
            is NotificationDeepLinks.Target.Conversation ->
                navController.navigate(Route.Conversation(target.conversationId))
            is NotificationDeepLinks.Target.Business ->
                navController.navigate(Route.BusinessDetail(target.businessId))
            is NotificationDeepLinks.Target.Post -> {
                // No standalone post route — hand off to the Feed tab, which opens the comments sheet.
                FeedDeepLinks.requestComments(target.postId)
                navController.popBackStack(Route.Main, inclusive = false)
            }
            is NotificationDeepLinks.Target.MarketplaceItem ->
                navController.navigate(Route.MarketplaceItem(target.itemId))
            is NotificationDeepLinks.Target.Event ->
                navController.navigate(Route.EventDetail(target.eventId))
            is NotificationDeepLinks.Target.Channel ->
                navController.navigate(Route.Channel(target.businessId))
            is NotificationDeepLinks.Target.News ->
                navController.navigate(Route.NewsDetail(target.articleId))
            is NotificationDeepLinks.Target.Orders ->
                navController.navigate(Route.OrderHistory)
            is NotificationDeepLinks.Target.Gem ->
                navController.navigate(gemRouteFor(target.kind, target.gemId))
            null -> Unit
        }
        if (pendingDeepLink != null) NotificationDeepLinks.consume()
    }

    // Wire the browser Back/Forward buttons + URL bar to this nav stack on web (no-op on native).
    // Re-enabled 2026-07-26 after the reconciliation was rewritten to be strictly one-way per
    // direction (the collector no longer calls history.go()), which was the loop that broke taps.
    BindWebNavHistory(navController)

    NavHost(navController = navController, startDestination = startDestination) {
        composable<Route.Onboarding> {
            OnboardingRoute(
                onFinished = {
                    navController.navigate(Route.Welcome) {
                        popUpTo(Route.Onboarding) { inclusive = true }
                    }
                },
            )
        }
        composable<Route.Welcome> {
            WelcomeScreen(
                onContinueAsUser = {
                    authViewModel.continueAsGuest()
                    // Drop Welcome from the back stack so system-Back from guest Home exits the app
                    // instead of returning to the marketing screen (matches the SignIn guest path).
                    navController.navigate(Route.Main) {
                        popUpTo(Route.Welcome) { inclusive = true }
                    }
                },
                onAddOrClaimBusiness = { navController.navigate(Route.AddBusiness) },
                onSignIn = { navController.navigate(Route.SignIn) },
                onCreateAccount = { navController.navigate(Route.SignUp) },
                onOpenTerms = { navController.navigate(Route.Terms) },
            )
        }
        composable<Route.SignIn> {
            SignInRoute(
                onAuthenticated = {
                    val cameFromApp = runCatching { navController.getBackStackEntry<Route.Main>() }.isSuccess
                    if (cameFromApp) {
                        navController.safePopBackStack()
                    } else {
                        navController.navigate(Route.Main) {
                            popUpTo(Route.Welcome) { inclusive = true }
                        }
                    }
                },
                onContinueAsGuest = {
                    navController.navigate(Route.Main) {
                        popUpTo(Route.Welcome) { inclusive = true }
                    }
                },
                onNavigateToSignUp = { navController.navigate(Route.SignUp) },
                onBack = { navController.safePopBackStack() },
            )
        }
        composable<Route.SignUp> {
            SignUpRoute(
                onAuthenticated = {
                    val cameFromApp = runCatching { navController.getBackStackEntry<Route.Main>() }.isSuccess
                    if (cameFromApp) {
                        navController.popBackStack(Route.Main, inclusive = false)
                    } else {
                        navController.navigate(Route.Main) {
                            popUpTo(Route.Welcome) { inclusive = true }
                        }
                    }
                },
                onSignIn = { navController.navigate(Route.SignIn) },
                onBack = { navController.safePopBackStack() },
            )
        }
        composable<Route.Main> {
            MainScaffold(
                onOpenCategories = { navController.navigate(Route.Categories) },
                onOpenCategory = { categoryId -> navController.navigate(Route.BusinessList(categoryId)) },
                onOpenSearch = { navController.navigate(Route.Search()) },
                onOpenMap = { navController.navigate(Route.Map) },
                onOpenBusiness = { id -> navController.navigate(Route.BusinessDetail(id)) },
                onOpenNews = { id -> navController.navigate(Route.NewsDetail(id)) },
                onOpenNewsList = { navController.navigate(Route.NewsList) },
                onOpenGems = { navController.navigate(Route.Gems) },
                onOpenAdmin = { navController.navigate(Route.Admin) },
                onOpenEvents = { navController.navigate(Route.Events) },
                onOpenSettings = { navController.navigate(Route.Settings) },
                onOpenSaved = { navController.navigate(Route.Saved) },
                // The Messages TAB hosts InboxRoute inline, so it needs the inbox's own
                // destinations; Route.Messages stays for deep links / notification taps.
                onOpenConversation = { id -> navController.navigate(Route.Conversation(id)) },
                onNewMessage = { navController.navigate(Route.NewMessage) },
                onOpenChannel = { id -> navController.navigate(Route.Channel(id)) },
                onOpenPeople = { navController.navigate(Route.People) },
                onOpenPeopleMap = { navController.navigate(Route.PeopleMap) },
                onOpenPerson = { uid -> navController.navigate(Route.PersonProfile(uid)) },
                onOpenDashboard = { navController.navigate(Route.Dashboard) },
                onOpenOrders = { navController.navigate(Route.OrderHistory) },
                onGetFreeTickets = { id -> navController.navigate(Route.EventTickets(id)) },
                onOpenEventDetail = { id -> navController.navigate(Route.EventDetail(id)) },
                onOpenTickets = { navController.navigate(Route.MyTickets) },
                onOpenMarketplaceItem = { id -> navController.navigate(Route.MarketplaceItem(id)) },
                onOpenNotifications = { navController.navigate(Route.Notifications) },
                onAddBusiness = { navController.navigate(Route.AddBusiness) },
                onOpenBlockedUsers = { navController.navigate(Route.BlockedUsers) },
                onOpenTerms = { navController.navigate(Route.Terms) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
                onSignOut = {
                    authViewModel.signOut()
                    navController.navigate(Route.Welcome) {
                        popUpTo(Route.Main) { inclusive = true }
                    }
                },
                onAccountDeleted = {
                    navController.navigate(Route.Welcome) {
                        popUpTo(Route.Main) { inclusive = true }
                    }
                },
            )
        }
        composable<Route.Notifications> {
            val uriHandler = LocalUriHandler.current
            // Opening the bell is the moment a member has shown they care about notifications.
            LaunchedEffect(Unit) { requestPushPermission() }
            NotificationsRoute(
                onBack = { navController.safePopBackStack() },
                onOpenConversation = { id -> navController.navigate(Route.Conversation(id)) },
                onOpenBusiness = { id -> navController.navigate(Route.BusinessDetail(id)) },
                onOpenPost = { postId ->
                    // No standalone post route — hand off to the Feed tab's comments sheet.
                    FeedDeepLinks.requestComments(postId)
                    navController.popBackStack(Route.Main, inclusive = false)
                },
                onOpenOrders = { navController.navigate(Route.OrderHistory) },
                onOpenEvent = { id -> navController.navigate(Route.EventDetail(id)) },
                onOpenChannel = { id -> navController.navigate(Route.Channel(id)) },
                onOpenGem = { kind, gemId -> navController.navigate(gemRouteFor(kind, gemId)) },
                // Campaign rows carry a universal-link URL; the deep-link bus parses + routes it
                // through the same path a tapped mahaleh.ca link takes. A link to any other page
                // (mahaleh.ca/welcome, an outside site) opens in the browser — never a dead tap.
                onOpenLink = { link -> if (!NotificationDeepLinks.offerUrl(link)) uriHandler.openUri(link) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.Admin> {
            AdminRoute(
                onBack = { navController.safePopBackStack() },
                // Admins can read pending docs (rules), so the normal detail screen is the review view.
                onOpenBusiness = { id -> navController.navigate(Route.BusinessDetail(id)) },
            )
        }
        composable<Route.BlockedUsers> {
            BlockedUsersRoute(onBack = { navController.safePopBackStack() })
        }
        composable<Route.Terms> {
            TermsRoute(onBack = { navController.safePopBackStack() })
        }
        composable<Route.MarketplaceItem> { entry ->
            val route = entry.toRoute<Route.MarketplaceItem>()
            MarketplaceItemDetailRoute(
                itemId = route.itemId,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
                onOpenConversation = { id -> navController.navigate(Route.Conversation(id)) },
                onOpenItem = { id -> navController.navigate(Route.MarketplaceItem(id)) },
            )
        }
        composable<Route.Dashboard> {
            DashboardRoute(
                onBack = { navController.safePopBackStack() },
                onAddBusiness = { navController.navigate(Route.AddBusiness) },
                onOpenBusiness = { id -> navController.navigate(Route.BusinessDetail(id)) },
                onManageReviews = { id -> navController.navigate(Route.ManageReviews(id)) },
                onManageProducts = { id -> navController.navigate(Route.ManageProducts(id)) },
                onManageOrders = { id -> navController.navigate(Route.ManageOrders(id)) },
                onAnalytics = { id -> navController.navigate(Route.ListingAnalytics(id)) },
                onOpenChannel = { id -> navController.navigate(Route.Channel(id)) },
                onEditListing = { id -> navController.navigate(Route.EditListing(id)) },
            )
        }
        composable<Route.EditListing> { entry ->
            EditListingRoute(
                businessId = entry.toRoute<Route.EditListing>().businessId,
                onBack = { navController.safePopBackStack() },
            )
        }
        composable<Route.ManageReviews> { entry ->
            val route = entry.toRoute<Route.ManageReviews>()
            ManageReviewsRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
            )
        }
        composable<Route.ListingAnalytics> { entry ->
            val route = entry.toRoute<Route.ListingAnalytics>()
            ListingAnalyticsRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
            )
        }
        composable<Route.Messages> {
            InboxRoute(
                onBack = { navController.safePopBackStack() },
                onOpenConversation = { id -> navController.navigate(Route.Conversation(id)) },
                onNewMessage = { navController.navigate(Route.NewMessage) },
                onOpenPeople = { navController.navigate(Route.People) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
                onOpenChannel = { id -> navController.navigate(Route.Channel(id)) },
            )
        }
        composable<Route.Saved> {
            diana.soleil.design.iraniancanadienbazzar.feature.profile.SavedScreen(
                onBack = { navController.safePopBackStack() },
                onOpenBusiness = { navController.navigate(Route.BusinessDetail(it)) },
                onOpenEvent = { navController.navigate(Route.EventDetail(it)) },
                onOpenNews = { navController.navigate(Route.NewsDetail(it)) },
            )
        }
        composable<Route.Settings> {
            val locale = koinInject<diana.soleil.design.iraniancanadienbazzar.locale.LocaleController>()
            val language by locale.language.collectAsState()
            val appearance = koinInject<diana.soleil.design.iraniancanadienbazzar.locale.AppearanceController>()
            val appearanceMode by appearance.mode.collectAsState()
            val isAdmin by authViewModel.isAdmin.collectAsState()
            val canModerate by authViewModel.canModerate.collectAsState()
            val session by authViewModel.session.collectAsState()
            val dashboardViewModel = koinViewModel<diana.soleil.design.iraniancanadienbazzar.feature.dashboard.DashboardViewModel>()
            val ownerState by dashboardViewModel.state.collectAsState()
            val prefs = koinInject<diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences>()
            val buildInfo = koinInject<diana.soleil.design.iraniancanadienbazzar.core.common.AppBuildInfo>()
            var showDeleteAccount by remember { mutableStateOf(false) }
            SettingsScreen(
                onBack = { navController.safePopBackStack() },
                developerMenuEnabled = buildInfo.isDebug,
                versionName = buildInfo.versionName,
                versionCode = buildInfo.versionCode,
                firebaseEnv = buildInfo.firebaseEnv,
                isGuest = session == null || session?.isAnonymous == true,
                paymentsEnabled = features.payments,
                currentLanguage = language,
                onLanguageSelected = locale::setLanguage,
                currentAppearance = appearanceMode,
                onAppearanceSelected = appearance::setMode,
                adminEnabled = canModerate,
                moderatorConsole = canModerate && !isAdmin,
                onOpenAdmin = { navController.navigate(Route.Admin) },
                dashboardEnabled = ownerState.businesses.isNotEmpty(),
                onOpenDashboard = { navController.navigate(Route.Dashboard) },
                onOpenBlockedUsers = { navController.navigate(Route.BlockedUsers) },
                onOpenTerms = { navController.navigate(Route.Terms) },
                // The tour anchors live in MainScaffold, so replaying it has to happen there: clear
                // the flag and pop back so the shell restarts it on the next frame.
                onReplayTour = {
                    prefs.featureTourRequested = true
                    navController.safePopBackStack()
                },
                onSignOut = {
                    authViewModel.signOut()
                    navController.navigate(Route.Welcome) { popUpTo(Route.Main) { inclusive = true } }
                },
                onDeleteAccount = { showDeleteAccount = true },
            )
            if (showDeleteAccount) {
                DeleteAccountSheet(
                    authViewModel = authViewModel,
                    userEmail = session?.email,
                    onDismiss = { showDeleteAccount = false },
                    onDeleted = {
                        navController.navigate(Route.Welcome) { popUpTo(Route.Main) { inclusive = true } }
                    },
                )
            }
        }
        composable<Route.Events> {
            EventsRoute(
                onBack = { navController.safePopBackStack() },
                onGetFreeTickets = { id -> navController.navigate(Route.EventTickets(id)) },
                onOpenEventDetail = { id -> navController.navigate(Route.EventDetail(id)) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.PeopleMap> {
            PeopleMapRoute(
                onBack = { navController.safePopBackStack() },
                onOpenConversation = { id -> navController.navigate(Route.Conversation(id)) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
                onOpenPerson = { uid -> navController.navigate(Route.PersonProfile(uid)) },
            )
        }
        composable<Route.People> {
            PeopleRoute(
                onBack = { navController.safePopBackStack() },
                onOpenConversation = { id -> navController.navigate(Route.Conversation(id)) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
                onOpenMap = { navController.navigate(Route.PeopleMap) },
                onOpenPerson = { uid -> navController.navigate(Route.PersonProfile(uid)) },
            )
        }
        composable<Route.PersonProfile> { entry ->
            val route = entry.toRoute<Route.PersonProfile>()
            PersonProfileRoute(
                uid = route.uid,
                onBack = { navController.safePopBackStack() },
                onOpenConversation = { id -> navController.navigate(Route.Conversation(id)) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.Channel> { entry ->
            val route = entry.toRoute<Route.Channel>()
            ChannelRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.NewMessage> {
            NewMessageRoute(
                onBack = { navController.safePopBackStack() },
                onOpenConversation = { id ->
                    // Replace the search screen in the back stack so Back from the thread returns to the inbox.
                    navController.navigate(Route.Conversation(id)) {
                        popUpTo(Route.NewMessage) { inclusive = true }
                    }
                },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.Conversation> { entry ->
            val route = entry.toRoute<Route.Conversation>()
            ConversationRoute(
                conversationId = route.conversationId,
                businessId = null,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.ChatWithBusiness> { entry ->
            val route = entry.toRoute<Route.ChatWithBusiness>()
            ConversationRoute(
                conversationId = null,
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.Search> { entry ->
            val route = entry.toRoute<Route.Search>()
            SearchRoute(
                initialQuery = route.query,
                onBack = { navController.safePopBackStack() },
                onBusinessClick = { id -> navController.navigate(Route.BusinessDetail(id)) },
                onCategoryClick = { categoryId -> navController.navigate(Route.BusinessList(categoryId)) },
                onAskCommunity = {
                    // Back to the shell; MainScaffold sees the pending ask and lands on Feed with
                    // the composer opened in Question mode.
                    FeedDeepLinks.requestAsk()
                    navController.popBackStack(Route.Main, inclusive = false)
                },
            )
        }
        composable<Route.Map> {
            MapRoute(
                onBack = { navController.safePopBackStack() },
                onBusinessClick = { id -> navController.navigate(Route.BusinessDetail(id)) },
            )
        }
        composable<Route.Categories> {
            CategoriesRoute(
                onBack = { navController.safePopBackStack() },
                onCategoryClick = { categoryId -> navController.navigate(Route.BusinessList(categoryId)) },
                onAddBusiness = { navController.navigate(Route.AddBusiness) },
            )
        }
        composable<Route.BusinessList> { entry ->
            val route = entry.toRoute<Route.BusinessList>()
            BusinessListRoute(
                categoryId = route.categoryId,
                categoryTitle = route.categoryId.replace('_', ' ').replaceFirstChar { it.uppercase() },
                onBack = { navController.safePopBackStack() },
                onBusinessClick = { id -> navController.navigate(Route.BusinessDetail(id)) },
                onAddBusiness = { navController.navigate(Route.AddBusiness) },
            )
        }
        composable<Route.BusinessDetail> { entry ->
            val route = entry.toRoute<Route.BusinessDetail>()
            BusinessDetailRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
                onShare = {},
                onChat = { navController.navigate(Route.ChatWithBusiness(route.businessId)) },
                onWriteReview = { navController.navigate(Route.WriteReview(route.businessId)) },
                onViewAllReviews = { navController.navigate(Route.AllReviews(route.businessId)) },
                onViewAllPhotos = { navController.navigate(Route.AllPhotos(route.businessId)) },
                onReport = {},  // handled inside the route (report sheet)
                onOpenClaim = { navController.navigate(Route.ClaimBusiness(route.businessId)) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
                onOpenChannel = { navController.navigate(Route.Channel(route.businessId)) },
                promotionsSlot = {
                    if (features.ordering) {
                        PromotionsSection(
                            businessId = route.businessId,
                            onProductClick = { pid -> navController.navigate(Route.ProductDetail(route.businessId, pid)) },
                        )
                    }
                },
                listingsSlot = {
                    if (features.ordering) {
                        ProductListingsSection(
                            businessId = route.businessId,
                            onProductClick = { pid -> navController.navigate(Route.ProductDetail(route.businessId, pid)) },
                        )
                    }
                },
            )
        }
        composable<Route.ClaimBusiness> { entry ->
            val route = entry.toRoute<Route.ClaimBusiness>()
            ClaimBusinessRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
                onSubmitted = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.ProductDetail> { entry ->
            val route = entry.toRoute<Route.ProductDetail>()
            ProductDetailRoute(
                businessId = route.businessId,
                productId = route.productId,
                onBack = { navController.safePopBackStack() },
                onOpenCart = { navController.navigate(Route.Cart) },
            )
        }
        composable<Route.Cart> {
            CartRoute(
                onBack = { navController.safePopBackStack() },
                onCheckout = { navController.navigate(Route.Checkout) },
            )
        }
        composable<Route.Checkout> {
            CheckoutRoute(
                onBack = { navController.safePopBackStack() },
                onPlaced = { orderId ->
                    navController.navigate(Route.OrderConfirmation(orderId)) {
                        popUpTo(Route.Cart) { inclusive = true }
                    }
                },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.OrderConfirmation> { entry ->
            val route = entry.toRoute<Route.OrderConfirmation>()
            OrderConfirmationRoute(
                orderId = route.orderId,
                onDone = { navController.popBackStack(Route.Main, inclusive = false) },
                onViewOrders = {
                    navController.navigate(Route.OrderHistory) {
                        popUpTo(Route.Main) { inclusive = false }
                    }
                },
            )
        }
        composable<Route.OrderHistory> {
            OrderHistoryRoute(
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.EventDetail> { entry ->
            val route = entry.toRoute<Route.EventDetail>()
            EventDetailRoute(
                eventId = route.eventId,
                onBack = { navController.safePopBackStack() },
                onGetFreeTickets = { id -> navController.navigate(Route.EventTickets(id)) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.EventTickets> { entry ->
            val route = entry.toRoute<Route.EventTickets>()
            EventTicketsRoute(
                eventId = route.eventId,
                onBack = { navController.safePopBackStack() },
                onIssued = { ticketId ->
                    navController.navigate(Route.TicketIssued(ticketId)) {
                        popUpTo(Route.Main) { inclusive = false }
                    }
                },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.MyTickets> {
            MyTicketsRoute(
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.TicketIssued> { entry ->
            val route = entry.toRoute<Route.TicketIssued>()
            MyTicketsRoute(
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
                highlightTicketId = route.ticketId,
            )
        }
        composable<Route.ManageProducts> { entry ->
            val route = entry.toRoute<Route.ManageProducts>()
            ManageProductsRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
            )
        }
        composable<Route.ManageOrders> { entry ->
            val route = entry.toRoute<Route.ManageOrders>()
            ManageOrdersRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
            )
        }
        composable<Route.AllReviews> { entry ->
            val route = entry.toRoute<Route.AllReviews>()
            AllReviewsRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.AllPhotos> { entry ->
            val route = entry.toRoute<Route.AllPhotos>()
            AllPhotosRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
            )
        }
        composable<Route.NewsList> {
            NewsListRoute(
                onBack = { navController.safePopBackStack() },
                onOpenArticle = { id -> navController.navigate(Route.NewsDetail(id)) },
            )
        }
        composable<Route.NewsDetail> { entry ->
            val route = entry.toRoute<Route.NewsDetail>()
            NewsDetailRoute(
                articleId = route.articleId,
                onBack = { navController.safePopBackStack() },
            )
        }
        composable<Route.WriteReview> { entry ->
            val route = entry.toRoute<Route.WriteReview>()
            WriteReviewRoute(
                businessId = route.businessId,
                onBack = { navController.safePopBackStack() },
                onSubmitted = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.AddBusiness> {
            AddBusinessRoute(
                onExit = { navController.safePopBackStack() },
                onOpenSearch = { navController.navigate(Route.Search()) },
            )
        }
        // ── Hidden Gems (docs/HIDDEN_GEMS_PLAN.md). Routes stay registered while the
        // `feature_hiddengems_enabled` kill switch is off — entry points hide, and the hub route
        // itself renders a not-available state (GemsHubRoute checks FeatureFlags), so a stale
        // shortcut can never crash into an unregistered destination.
        composable<Route.Gems> {
            GemsHubRoute(
                onBack = { navController.safePopBackStack() },
                onOpenJokes = { navController.navigate(Route.GemsJokes()) },
                onOpenRecipes = { navController.navigate(Route.GemsRecipes) },
                onOpenDanestaniha = { navController.navigate(Route.GemsDanestaniha()) },
                onOpenShahnameh = { navController.navigate(Route.GemsShahnameh) },
                onOpenPoetry = { navController.navigate(Route.GemsPoetry) },
                onOpenStories = { navController.navigate(Route.GemsStories) },
                onOpenFal = { navController.navigate(Route.GemsFal) },
                onOpenRecipe = { id -> navController.navigate(Route.GemsRecipeDetail(id)) },
                onOpenTale = { id -> navController.navigate(Route.GemsTaleDetail(id)) },
                onOpenPoem = { id -> navController.navigate(Route.GemsPoemDetail(id)) },
                onOpenStory = { id -> navController.navigate(Route.GemsStoryDetail(id)) },
            )
        }
        composable<Route.GemsPoetry> {
            PoetryRoute(
                onBack = { navController.safePopBackStack() },
                onOpenPoet = { id -> navController.navigate(Route.GemsPoet(id)) },
            )
        }
        composable<Route.GemsPoet> { entry ->
            PoetPoemsRoute(
                poetId = entry.toRoute<Route.GemsPoet>().poetId,
                onBack = { navController.safePopBackStack() },
                onOpenPoem = { id -> navController.navigate(Route.GemsPoemDetail(id)) },
            )
        }
        composable<Route.GemsPoemDetail> { entry ->
            PoemDetailRoute(
                poemId = entry.toRoute<Route.GemsPoemDetail>().poemId,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.GemsFal> {
            FalRoute(
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.GemsStories> {
            StoriesRoute(
                onBack = { navController.safePopBackStack() },
                onOpenStory = { id -> navController.navigate(Route.GemsStoryDetail(id)) },
            )
        }
        composable<Route.GemsStoryDetail> { entry ->
            StoryDetailRoute(
                storyId = entry.toRoute<Route.GemsStoryDetail>().storyId,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.GemsJokes> { entry ->
            JokesRoute(
                focusJokeId = entry.toRoute<Route.GemsJokes>().focusJokeId,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.GemsDanestaniha> { entry ->
            DanestanihaRoute(
                focusFactId = entry.toRoute<Route.GemsDanestaniha>().focusFactId,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.GemsShahnameh> {
            ShahnamehRoute(
                onBack = { navController.safePopBackStack() },
                onOpenTale = { id -> navController.navigate(Route.GemsTaleDetail(id)) },
            )
        }
        composable<Route.GemsTaleDetail> { entry ->
            val route = entry.toRoute<Route.GemsTaleDetail>()
            TaleDetailRoute(
                taleId = route.taleId,
                onBack = { navController.safePopBackStack() },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.GemsRecipes> {
            RecipesRoute(
                onBack = { navController.safePopBackStack() },
                onOpenRecipe = { id -> navController.navigate(Route.GemsRecipeDetail(id)) },
            )
        }
        composable<Route.GemsRecipeDetail> { entry ->
            val route = entry.toRoute<Route.GemsRecipeDetail>()
            RecipeDetailRoute(
                recipeId = route.recipeId,
                onBack = { navController.safePopBackStack() },
                onStartCooking = { navController.navigate(Route.GemsCookMode(route.recipeId)) },
                onFindIngredients = { query -> navController.navigate(Route.Search(query)) },
                onRequireSignIn = { navController.navigate(Route.SignIn) },
            )
        }
        composable<Route.GemsCookMode> { entry ->
            val route = entry.toRoute<Route.GemsCookMode>()
            CookModeRoute(
                recipeId = route.recipeId,
                onClose = { navController.safePopBackStack() },
            )
        }
    }
}

/**
 * Maps a daily-gem push/bell row to the surface that can show it. Recipes and tales have detail
 * screens; jokes and danestaniha are swipe readers, so they open the reader ON the pushed item —
 * opening at the top of an 80-card reader left people hunting for the joke they were sent (owner
 * report 2026-09-14). An unknown kind (a newer server than this build) falls back to the hub rather
 * than dropping the tap on the floor.
 */
private fun gemRouteFor(kind: String, gemId: String): Route = when (kind) {
    "recipe" -> if (gemId.isNotBlank()) Route.GemsRecipeDetail(gemId) else Route.GemsRecipes
    "tale" -> if (gemId.isNotBlank()) Route.GemsTaleDetail(gemId) else Route.GemsShahnameh
    "poem" -> if (gemId.isNotBlank()) Route.GemsPoemDetail(gemId) else Route.GemsPoetry
    "story" -> if (gemId.isNotBlank()) Route.GemsStoryDetail(gemId) else Route.GemsStories
    "joke" -> Route.GemsJokes(gemId.ifBlank { null })
    "fact" -> Route.GemsDanestaniha(gemId.ifBlank { null })
    else -> Route.Gems
}
